/**
 * Sorts an array of objects alphabetically based on a specified key.
 *
 * @param {keyof T} key - The key to sort by.
 * @returns {T[]} The sorted array of objects.
 */
Array.prototype.sortAlphabeticallyByKey = function<T>(
  this: T[],
  key: keyof T
): T[] {
  return this.sort((a, b) => {
    const valueA = a[key];
    const valueB = b[key];

    if (typeof valueA === "string" && typeof valueB === "string") {
      return valueA.localeCompare(valueB);
    }

    if (valueA < valueB) {
      return -1;
    } else if (valueA > valueB) {
      return 1;
    } else {
      return 0;
    }
  });
};

declare global {
  interface Array<T> {
    sortAlphabeticallyByKey(this: T[], key: keyof T): T[];
  }
}

export {};
